import React from 'react'
import { Typography, Card } from 'antd'
import { formatCurrency } from '../../utils/currency'

const { Text } = Typography

interface Props {
  total: number
  margin: number
  accessories?: boolean
}

export const MaterialTotal: React.FC<Props> = ({
  total,
  margin,
  accessories
}) => {
  return (
    <Card size="small" className="mt-4">
      <div className="flex justify-between items-center">
        <div>
          <Text strong>{accessories ? 'Accessories' : 'Finishes'} Total:</Text>
          <Text type="secondary" className="ml-2">
            (Margin: {(margin ?? 0).toFixed(1)}%)
          </Text>
        </div>
        <Text strong>{formatCurrency(total)} per item</Text>
      </div>
    </Card>
  )
}
